<template>
    <div>
        <data-table
            :headers="serviceHeaders"
            v-model="services"
            :items-per-page="10"
            title="Services"
            filterable
        >
            <template v-slot:item.enabled="{ item }">
                <md-switch
                    class="md-layout-item"
                    v-model="item.enabled"
                    @change="serviceChange(item)"
                ></md-switch>
            </template>
            <template v-slot:item.opt_in="{ item }">
                <md-switch
                    class="md-layout-item"
                    v-model="item.opt_in"
                    @change="serviceChange(item)"
                ></md-switch>
            </template>
            <template v-slot:item.service_action="{ item }">
                <loading-icon-button
                    @click="editService(item)"
                    tooltip="Edit Service"
                    :loading="
                        progress_indicator_service.edit_service_id == item.id
                    "
                >
                    edit
                </loading-icon-button>
                <loading-icon-button
                    @click="deleteService(item)"
                    tooltip="Delete Service"
                    :loading="progress_indicator_service.remove_service_id == item.id"
                    >
                    clear
                </loading-icon-button>
            </template>
        </data-table>
    </div>
</template>

<script>
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";

export default {
    components: {
        DataTable,
        LoadingIconButton,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: null,
            default: () => null,
        },
    },
    data() {
        return {
            serviceHeaders: [
                {
                    text: "ID",
                    value: "id",
                    sort: true,
                    search: true,
                },
                {
                    text: "Service Name",
                    value: "name",
                    sort: true,
                    search: true,
                },
                {
                    text: "Description",
                    value: "description",
                    sort: false,
                    search: true,
                },
                {
                    text: "Enabled/Disabled",
                    value: "enabled",
                    sort: true,
                    search: true,
                },
                {
                    text: "Opt In",
                    value: "opt_in",
                    sort: true,
                    search: true,
                },
                {
                    text: "Created On",
                    value: "created_at",
                    filter: filters.dateonly,
                    sort: true,
                    search: true,
                },
                {
                    text: "Updated On",
                    value: "updated_at",
                    filter: filters.dateonly,
                    sort: true,
                    search: true,
                },
                {
                    text: "Action",
                    value: "service_action",
                    sort: false,
                },
            ],
            progress_indicator_service: {
                edit_service_id: false,
                remove_service_id: false,
            },
        };
    },
    computed: {
        services() {
            return this.items ?? [];
        },
    },
    methods: {
        editService(service) {
            this.$emit("edit-service", service);
        },
        deleteService(service) {
            this.$emit("delete-service", service);
        },
        serviceChange(service) {
            this.$emit("service-change", service);
        },
        ...filters,
    },
    filters: {
        ...filters,
    },
};
</script>
